<template>
	<div>
		<ul :class="{ 'grid' : true, 'grid--loading' : $wait.is('members') }">
			<!-- Error while loading -->
			<li class="grid__error col-12" v-if="error">
				<span class="h2">Unable to load members.</span>
				<button class="btn btn--link" @click.prevent="getMembers">Retry</button>
			</li>

			<template v-else-if="members.length">
				<li v-for="member in filteredMembers(members)" class="col-6 col-md-3">
					<div class="card card--toggle card--image" v-if="selectable">
						<input :id="`member-${member.id}`" type="checkbox" :value="member.id" hidden v-model="selected"/>
						<label :for="`member-${member.id}`">
                            <span v-if="member.countries" class="card__flags">
                                <img
                                    v-for="(country, index) in member.countries"
                                    :src="country.flag"
                                    :key="index"
                                    alt=""
                                    v-tippy="country.name"
                                />
                            </span>
							<img :src="`/images/logo/${member.id}`" :alt="member.name" />

						</label>
					</div>

                    <MemberCard v-else :member="member" :flags="true"></MemberCard>
				</li>
			</template>
		</ul>
	</div>
</template>

<script>
	import API from '@api';
	import MemberCard from '../Member/MemberCard';

	export default {
		name: 'GridMembers',
		components: { MemberCard },
		props: {
			filters: {
				type: Object,
				default: () => ({}),
			},
			selectable: {
				type: Boolean,
				default: false,
			},
			hideMergers: {
				type: Boolean,
				default: false,
			},
			value: {
				type: Array,
				default: () => [],
			},
		},
		created() {
			this.getMembers();
		},
		data() {
			return {
				members: [],
				error: false,
				selected: [],
			}
		},
		methods: {
			getMembers() {
				this.$wait.start('members');

				API.getMembers({'per_page': 100, 'sort': "name|asc"})
                    .then(response => {
                        this.error = false;
                        this.members = response;
                    })
                    .catch(() => {
                        this.error = true;
                    })
                    .finally(() => {
                        this.$wait.end('members');
                    });
			},
			filteredMembers() {
				let members = [...(this.members ?? [])]
                    .filter(member => parseInt(member.id) !== 201 || !this.hideMergers);

                if(this.filters.region) {
                    members = members
                        .filter(member => parseInt(this.filters.region) === parseInt(member.region_id));
                }

                if(this.filters.country) {
                    members = members
                        .filter(member => {
                            return (member.countries ?? [])
                                .map(c => parseInt(c.id))
                                .includes(parseInt(this.filters.country))
                        });
                }

				if(this.filters.query) {
					members = members
                        .filter(member => member.name.toLowerCase().indexOf(this.filters.query.toLowerCase()) >= 0);
				}

				return members;
			},
		},
		watch: {
			selected() {
				this.$emit('input', this.selected);
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "~reflex-grid/scss/includes/variables";
	@import "~reflex-grid/scss/includes/mixins";
	@import "~@/theme/_variables.scss";

	.card {
		@include flex-direction(column);

		label {
			padding: 2rem;
			cursor: pointer;
			min-height: 0;
			border: 0.1rem solid #cfcfcf;
			border-radius: 0.4rem;
			@include flex(1, 1, auto);
			@include align-self(stretch);
			@include display-flex;
		}

		input:checked + label {
			border-color: $accent;
            border-radius: 0.2rem;
		}
	}
</style>
